export default __webpack_public_path__ + "static/IMDA_SME_Vertical_Medium-63e9c893c60bd660e846f12bb682e2d0.png";